import {
  Component,
  ElementRef,
  inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  CompanyDto,
  LiveFeedControllerService,
  LiveFeedUserDto,
} from '../../api-client';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-live-feed',
  templateUrl: './live-feed.component.html',
  styleUrls: ['./live-feed.component.scss'],
})
export class LiveFeedComponent implements OnInit, OnDestroy {
  private _liveFeed = inject(LiveFeedControllerService);

  private backendUrl = environment.url;

  public company: any = null;

  public isFullscreen: boolean = false;

  public id: number;

  public rankingList: LiveFeedUserDto[] = [];

  public lastRefreshTime: Date = new Date();

  public logoUrl: string = '';

  public displayedColumns: string[] = [
    'trophy',
    'ranking',
    'username',
    'totalPoints' /*, 'lastTransactionTime'*/,
  ];

  private tableDataInterval;

  @ViewChild('tableContainer') tableContainer: ElementRef;

  constructor(private route: ActivatedRoute) {
    this.route.params.subscribe({
      next: (params) => {
        this.id = params['id'];
        this.refreshTableData();
      },
    });
  }

  ngOnInit(): void {
    this.tableDataInterval = setInterval(() => this.refreshTableData(), 180000);

    setTimeout(() => {
      this.autoScroll();
    }, 1000);
  }

  ngOnDestroy(): void {
    clearInterval(this.tableDataInterval);
  }

  private refreshTableData(): void {
    this._liveFeed.getCompanyLiveFeed(this.id).subscribe({
      next: (value) => {
        this.company = value.companyDto;
        this.logoUrl = this.backendUrl + this.company.logo;
        this.rankingList = value.liveFeedSpenders.map((user) => {
          const now = new Date();
          const lastTransactionTimeUTC = new Date(user.lastTransactionTime);
          const lastTransactionTimeLocal = new Date(
            lastTransactionTimeUTC.getTime() -
              lastTransactionTimeUTC.getTimezoneOffset() * 60000
          );
          const timeDiff =
            (now.getTime() - lastTransactionTimeLocal.getTime()) / 1000 / 60; // in minutes
          return {
            ...user,
            showLastTransaction: timeDiff < 3,
          };
        });
        this.lastRefreshTime = new Date();
      },
    });
  }

  public requestFullscreen(): void {
    let elem: any = document.documentElement;
    let methodToBeInvoked =
      elem.requestFullscreen ||
      elem['webkitRequestFullScreen'] ||
      elem['mozRequestFullscreen'] ||
      elem['msRequestFullscreen'];
    if (methodToBeInvoked) methodToBeInvoked.call(elem);

    this.isFullscreen = true;
  }

  private autoScroll(): void {
    const container = this.tableContainer.nativeElement;
    const rowHeight = container.querySelector('tr').clientHeight;
    const rowsPerPage = 10;
    const scrollAmount = rowHeight * rowsPerPage;

    setInterval(() => {
      if (
        container.scrollTop + container.clientHeight + 5 >=
        container.scrollHeight
      ) {
        container.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        container.scrollBy({ top: scrollAmount, behavior: 'smooth' });
      }
    }, 7000);
  }

  public getPointsWithSuffix(points: number, withPlusOrMinus: boolean): string {
    const lastDigit = points % 10;
    const lastTwoDigits = points % 100;
    let finalValue: string;
    if (lastTwoDigits < 10 || lastTwoDigits > 20) {
      if (lastDigit === 1) {
        finalValue = points + ' bod';
      } else if (lastDigit > 1 && lastDigit < 5) {
        finalValue = points + ' boda';
      } else {
        finalValue = points + ' bodova';
      }
    } else {
      finalValue = points + ' bodova';
    }
    if (withPlusOrMinus) {
      finalValue = points > 0 ? '+ ' + finalValue : finalValue;
    }
    return finalValue;
  }
}
